// The verdict a report shows (DESIGN_SPEC §12.1). The score is the stream's (else the job record's, else
// behavior-report.json's), the same number the lens shows; the tags come from behavior-report.json whenever it has
// any, since it is authoritative after the end. Idempotent: a merged verdict passes through unchanged.
//   reportVerdict(stream, report?) → VerdictSnap | null   source "behavior-report" when the report supplied the tags or the verdict
import { verdictLabelFor } from "../eventStore";
import type { BehaviorReport } from "@/types";
import type { JobStream, VerdictSnap } from "./types";

function iocTotal(report: BehaviorReport): number {
  return Object.values(report.iocs ?? {}).reduce((n, list) => n + (list?.length ?? 0), 0);
}

export function reportVerdict(stream: Pick<JobStream, "verdict">, report?: BehaviorReport | null): VerdictSnap | null {
  const v = stream.verdict;
  const tags = report?.tags?.length ? report.tags : null;
  if (v) return tags && v.tags !== tags ? { ...v, tags, source: "behavior-report" } : v;
  const rv = report?.verdict;
  const score = Number(rv?.score);
  if (!rv || !Number.isFinite(score)) return null;
  const label = rv.label;
  return {
    label: label === "benign" || label === "suspicious" || label === "malicious" ? label : verdictLabelFor(score),
    score,
    maxSeverity: rv.max_severity ?? "",
    tagCount: rv.tag_count ?? report?.tags?.length ?? 0,
    iocCount: iocTotal(report!),
    tags: report?.tags ?? [],
    seq: 0,
    source: "behavior-report",
  };
}
